<template>
  <aw-spinner />
</template>

<script setup>
  import { onBeforeMount, defineAsyncComponent } from 'vue';
  import { useHead, navigateTo, useRoute, useNuxtApp } from 'nuxt/app';
  import { setErrorNotification } from '~~/common/utils/helper';
  import { useNotificationStore } from '~~/common/stores/notification';
  const AwSpinner = defineAsyncComponent(() => import('~~/common/components/Common/AwSpinner.vue'));

  useHead({
    meta: [
      {
        name: 'robots',
        content: 'noindex,nofollow',
      },
    ],
  });

  const nuxtApp = useNuxtApp();
  const { $api, $localePath } = nuxtApp;

  onBeforeMount(async () => {
    const notificationStore = useNotificationStore();
    const route = useRoute();
    let statusToken = null;
    try {
      const PAGE_ACTIVATE_REG = /^\/activate_registration\//;
      const PAGE_USER_EMAIL_UPDATE = /^\/user_email_update\//;
      let redirectUrl = () => '/';
      const pages = [
        {
          regex: PAGE_ACTIVATE_REG,
          apiEndpoint: '/me/activate',
          statusToken: {
            success: 'registration.activation.successful',
            error: 'registration.activation.error',
          },
          redirectUrl,
        },
        {
          regex: PAGE_USER_EMAIL_UPDATE,
          apiEndpoint: '/me/user_email_change',
          statusToken: {
            success: 'account.email_validation.success',
            error: 'account.email_validation.error',
          },
          redirectUrl,
        },
      ];

      let apiEndpoint;
      ({
        apiEndpoint,
        statusToken,
        redirectUrl,
      } = pages.find(settings => settings.regex.test(route.path)) || {});


      await $api.$put(`${apiEndpoint}/${route.params?.hash}`, {});
      if (statusToken?.success) {
        notificationStore.pushSuccess({
          text: {
            titleToken: statusToken.success,
          },
        });
      }
      await navigateTo({ path: $localePath(await redirectUrl?.()) });
    } catch (error) {
      if (statusToken?.error) {
        notificationStore.pushError({
          text: {
            titleToken: statusToken.error,
          },
        });
      }
      setErrorNotification({ nuxtApp, error, manualClose: true });
      await navigateTo({ path: $localePath('/') });
    }
  });
</script>
